import Vue from "vue";
import VueRouter from "vue-router";
import { Message } from "element-ui";
import { getToken } from "@/util/session";
import { getBookUserStatus } from "@/api/bookUser";
import { hasExamination } from "@/api/student";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/login.vue")
  },
  {
    path: "/downloadPage",
    name: "downloadPage",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/downloadPage.vue")
  },

  {
    path: "/home",
    name: "home",
    component: () => import("../views/home.vue"),
    children: [
      {
        path: "/",
        component: () => import("../components/layout/StudentShell.vue"),
        children: [
          {
            path: "",
            redirect: "/examination"
          },
          {
            path: "/examination",
            name: "examination",
            component: () =>
              import("../views/examination/examination/index.vue")
          },
          {
            path: "/bist",
            name: "bist",
            component: () => import("../views/examination/bist/index.vue")
          },
          {
            path: "/task",
            name: "task",
            component: () => import("../views/examination/task/index.vue")
          },
          {
            path: "/practice",
            name: "practice",
            component: () => import("../views/examination/practice/index.vue")
          },
          {
            path: "/classTest",
            name: "classTest",
            component: () => import("../views/examination/classTest/index.vue")
          },
          {
            path: "/questions",
            name: "questions",
            component: () => import("../views/examination/questions/index.vue")
          },
          {
            path: "/practiceQuestions",
            name: "practiceQuestions",
            component: () =>
              import("../views/examination/practiceQuestions/index.vue")
          },
          {
            path: "/classicQuestions",
            name: "classicQuestions",
            component: () =>
              import("../views/examination/classicQuestions/index.vue")
          },
          {
            path: "/errQuestions",
            name: "errQuestions",
            component: () =>
              import("../views/examination/errQuestions/index.vue")
          },
          {
            path: "/portrait",
            name: "portrait",
            component: () => import("../views/examination/portrait/index.vue")
          },
          {
            path: "/user",
            name: "user",
            component: () => import("../views/examination/user/index.vue")
          },
          {
            path: "/bookCampusAuth",
            name: "bookCampusAuth",
            component: () => import("../views/book/campusAuth/index.vue")
          },
          {
            path: "/bookCourse",
            name: "bookCourse",
            component: () => import("../views/book/course/index.vue")
          },
          {
            path: "/bookTextbook",
            name: "bookTextbook",
            component: () => import("../views/book/textbook/index.vue")
          },
          {
            path: "/bookKnowledge",
            name: "bookKnowledge",
            component: () => import("../views/book/knowledge/index.vue")
          },
          {
            path: "/notice",
            name: "notice",
            component: () => import("../views/examination/notice/index.vue")
          },
          {
            path: "/list",
            name: "list",
            component: () => import("../views/examination/list.vue")
          }
        ]
      },
      {
        path: "/bistAnalysis",
        name: "bistAnalysis",
        component: () => import("../views/examination/bistAnalysis.vue")
      },
      {
        path: "/creatSubject",
        name: "creatSubject",
        component: () => import("../views/examination/creatSubject/index.vue")
      },
      {
        path: "selfTest",
        name: "selfTest",
        component: () => import("../views/examination/self-test.vue"),
        meta: {
          keepAlive: true
        }
      },
      {
        path: "detail",
        name: "detail",
        component: () => import("../views/examination/detail.vue")
      },
      {
        path: "test-detail",
        name: "test-detail",
        component: () => import("../views/examination/test-detail.vue")
      },
      {
        path: "/about",
        name: "About",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import("../views/examination/About.vue")
      },
      {
        path: "/work-test-detail",
        name: "work-test-detail",
        component: () => import("../views/examination/work-test-detail.vue")
      },
      {
        path: "/workhistory/:taskId",
        name: "work-history-detail",
        component: () => import("../views/examination/work-history-detail.vue")
      },
      {
        path: "/workTest/:taskId",
        name: "workTest",
        component: () => import("../views/examination/workTest.vue")
      }
    ]
  },
  {
    path: "/exam",
    name: "exam",
    component: () => import("../views/examination/exam/index.vue")
  },
  { path: "*", redirect: "/login" }
];

const router = new VueRouter({
  routes
});

const PUBLIC_ROUTE_NAMES = new Set(["login", "downloadPage"]);
const BOOK_ONLY_ROUTE_NAMES = new Set([
  "bookCampusAuth",
  "bookCourse",
  "bookTextbook",
  "bookKnowledge"
]);
const BOOK_JOIN_CLASS_MESSAGE = "要使用功能，必须先加入班级";

router.beforeEach(async (to, from, next) => {
  const hasToken = !!getToken();
  if (!hasToken) {
    if (PUBLIC_ROUTE_NAMES.has(to.name)) {
      next();
      return;
    }
    next({ name: "login" });
    return;
  }

  if (to.name === "login") {
    next({ path: "/home" });
    return;
  }

  // 校验当前是否有正在进行的考试
  try {
    const hasExamRes = await hasExamination();
    if (hasExamRes && (hasExamRes.code === 200 || hasExamRes.code === 0)) {
      const isExamActive = hasExamRes.data === true;
      if (isExamActive) {
        if (to.name !== "examination" && to.name !== "exam") {
          Message.warning("当前学校正在进行考试，其他功能暂时不可用");
          next({ name: "examination", replace: true });
          return;
        }
      }
    }
  } catch (e) {
    // 忽略状态探测失败，避免阻断登录后路由
  }

  try {
    const res = await getBookUserStatus();
    if (res && (res.code === 200 || res.code === 0)) {
      const status = res.data || {};
      const isBookPersonal = status.registerChannel === "book_personal";
      const isCampusVerified = status.campusAuthStatus === "VERIFIED";
      const generalAccessAllowed = status.generalAccessAllowed === true;
      const isJoinClassRequired = status.nextStep === "JOIN_CLASS";

      if (isBookPersonal && !isCampusVerified) {
        if (to.name !== "bookCampusAuth") {
          next({ name: "bookCampusAuth", replace: true });
          return;
        }
        next();
        return;
      }

      if (to.name === "bookCampusAuth") {
        next({ name: "bookCourse", replace: true });
        return;
      }

      if (isBookPersonal && isCampusVerified && !generalAccessAllowed) {
        if (!BOOK_ONLY_ROUTE_NAMES.has(to.name)) {
          Message.warning(
            isJoinClassRequired
              ? BOOK_JOIN_CLASS_MESSAGE
              : "请先在智慧数学课程中激活教材后再使用其他功能"
          );
          next({ name: "bookCourse", replace: true });
          return;
        }
      }
    }
  } catch (e) {
    // 忽略状态探测失败，避免阻断登录后路由
  }

  next();
});

export default router;
